/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";

import TkInputInspectionCreateButton from "../input/TkInputInspectionCreateButton";
import TkInputInspectionUpdateButton from "../input/TkInputInspectionUpdateButton";

function TkInputInspectionDetail(props) {
    const { id, onSelectMst, onEmpty } = props;

    const table = "TkInputInspection";
    const view = "TkVwInputInspection";

    const [tkInputInspectionSchema, setTkInputInspectionSchema] = useState();
    const [momSysInspectionSchema, setMomSysInspectionSchema] = useState();

    const [tkInputInspectionGrid, setTkInputInspectionGrid] = useState();
    const [tkInputInspectionApi, setTkInputInspectionApi] = useState();
    const [tkInputInspectionDataIsEmpty, setTkInputInspectionDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);
            let momSysInspectionSchema = await getSchema("MomSysInspection");

            if (mounted) {
                setTkInputInspectionSchema(schema);
                setMomSysInspectionSchema(momSysInspectionSchema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        console.log(onSelectMst)
        if (tkInputInspectionApi) {
            tkInputInspectionApi.refresh();
        }
    }, [onSelectMst?.inputInspectionContainerId, onSelectMst?.inputState]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    return (
        <BasicCrudScreenType
            id={id}
            table={table}
            view={view}
            headerTitle={t("term.tkInputInspectionDetail")}
            noCreate
            noEdit
            noDelete
            noExcel
            onModifyViewUrl={(url) => {
                if (onSelectMst?.inputInspectionContainerId) {
                    url += "/" + onSelectMst?.inputInspectionContainerId;

                    return url;
                }

                return (url += "/undefined");
            }}
            onInitialized={(grid) => {
                setTkInputInspectionGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkInputInspectionApi(api);
            }}
            onLoadData={(data) => {
                setTkInputInspectionDataIsEmpty(data.length < 1 ? true : false);
                onEmpty(data.length < 1 ? true : false);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkInputInspectionSchema && tkInputInspectionSchema.name}
                        accessMethod="POST"
                    >
                        <TkInputInspectionCreateButton
                            id={"TkInputInspection"}
                            schema={tkInputInspectionSchema}
                            color="primary"
                            createButtonName="create"
                            onSuccess={onSuccess}
                            refresh={tkInputInspectionApi}
                            disabled={onSelectMst?.inputState}
                            onSelectMst={onSelectMst}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkInputInspectionSchema && tkInputInspectionSchema.name}
                        accessMethod={
                            tkInputInspectionSchema && (tkInputInspectionSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkInputInspectionUpdateButton
                            id={"TkInputInspection"}
                            schema={tkInputInspectionSchema}
                            grid={tkInputInspectionGrid}
                            refresh={tkInputInspectionApi}
                            disabled={tkInputInspectionDataIsEmpty || onSelectMst?.inputState}
                            onSuccess={onSuccess}
                            modifyUrlCallback={(url) => `/api/TkInputInspection`}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkInputInspectionSchema && tkInputInspectionSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id={"TkInputInspection"}
                            schema={momSysInspectionSchema}
                            grid={tkInputInspectionGrid}
                            refresh={tkInputInspectionApi}
                            color="secondary"
                            disabled={tkInputInspectionDataIsEmpty || onSelectMst?.inputState}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                        />
                    </AccessControl>
                    <AccessControl
                        accessTarget={tkInputInspectionSchema && tkInputInspectionSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={"TkInputInspection"}
                            grid={tkInputInspectionGrid}
                            view={view}
                            color="primary"
                            disabled={tkInputInspectionDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            exportFormatItem={() => { }}
        />
    );
}

export default TkInputInspectionDetail;
